import { Phone } from "lucide-react";
import { PHONE_TEL } from "@/site";
import { useQuote } from "@/quote-context";

export const MobileCallBar = () => {
    const { openQuote } = useQuote();
    return (
        <div
            data-testid="mobile-call-bar"
            className="fixed inset-x-0 bottom-0 z-40 flex gap-2 border-t border-white/10 bg-navy-950/95 p-3 backdrop-blur-md md:hidden"
            style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
        >
            <a
                data-testid="mobile-call-now-button"
                href={PHONE_TEL}
                className="flex flex-1 items-center justify-center gap-2 rounded-full bg-gold py-3.5 text-sm font-extrabold uppercase tracking-wider text-navy-950"
            >
                <Phone className="h-4 w-4" />
                Call Now — 24/7
            </a>
            <button
                data-testid="mobile-quote-button"
                onClick={() => openQuote()}
                className="rounded-full border border-white/25 px-5 text-sm font-bold text-white"
            >
                Quote
            </button>
        </div>
    );
};
